import Vue from "vue";
import Router, { RouteConfig } from "vue-router";
import Home from "./views/Home.vue";
import BaseView from "./views/base.vue";

import BaseHistory from "@/modules/historico/base-history.vue";
//import HistoryTable from "@/modules/historico/table.vue";
import HistoryChildTable from "@/modules/historico/table-child.vue";
import HistoryAdd from "@/modules/historico/add.vue";
import HistoryEdit from "@/modules/historico/edit.vue";

import LanguageConfigBase from "@/modules/language/base.vue";
import LanguageTable from "@/modules/language/table.vue";
import LanguageAdd from "@/modules/language/add.vue";
import LanguageEdit from "@/modules/language/edit.vue";

import LanguageGroupBase from "@/modules/language/languageGroup/base.vue";
import LanguageGroupTable from "@/modules/language/languageGroup/table.vue";
import LanguageGroupAdd from "@/modules/language/languageGroup/add.vue";
import LanguageGroupEdit from "@/modules/language/languageGroup/edit.vue";

import LanguageLabelBase from "@/modules/language/languageLabel/base.vue";
import LanguageLabelTable from "@/modules/language/languageLabel/table.vue";
import LanguageLabelAdd from "@/modules/language/languageLabel/add.vue";
import LanguageLabelEdit from "@/modules/language/languageLabel/edit.vue";

import BaseArea from "@/modules/coding/base.vue";
import AreaTable from "@/modules/coding/table.vue";
import AreaAdd from "@/modules/coding/add.vue";
import AreaEdit from "@/modules/coding/edit.vue";

import FieldAreaBase from "@/modules/coding/fieldArea/base.vue";
import FieldAreaTable from "@/modules/coding/fieldArea/table.vue";
import FieldAreaAdd from "@/modules/coding/fieldArea/add.vue";
import FieldAreaEdit from "@/modules/coding/fieldArea/edit.vue";

import ResearchLineBase from "@/modules/coding/researchLine/base.vue";
import ResearchLineTable from "@/modules/coding/researchLine/table.vue";
import ResearchLineAdd from "@/modules/coding/researchLine/add.vue";
import ResearchLineEdit from "@/modules/coding/researchLine/edit.vue";

import ResearchCenterCollaboratorBase from "@/modules/researchCenterCollaborator/base.vue"
import ResearchCenterCollaboratorAdd from "@/modules/researchCenterCollaborator/add.vue"
import ResearchCenterCollaboratorTable from "@/modules/researchCenterCollaborator/table.vue"

import ResearchTable from "@/modules/research/researchCenterType/table.vue";
import ResearchAdd from "@/modules/research/researchCenterType/add.vue";
import ResearchEdit from "@/modules/research/researchCenterType/edit.vue";

import viewDetail from "@/modules/announcement/viewDetails.vue";

import ResearchCenterTable from "@/modules/research/researchCenter/table.vue";
import ResearchCenterAdd from "@/modules/research/researchCenter/add.vue";
import ResearchCenterEdit from "@/modules/research/researchCenter/edit.vue";

import KeyValueTable from "./modules/key-value/table.vue";
import KeyValueAdd from "./modules/key-value/add.vue";
import KeyValueEdit from "./modules/key-value/edit.vue";

import AcademicTitleTable from "./modules/academic/academicTitle/table.vue";
import AcademicTitleAdd from "./modules/academic/academicTitle/add.vue";
import AcademicTitleEdit from "./modules/academic/academicTitle/edit.vue";

import AcademicAreaTable from "./modules/academic/academicArea/table.vue";
import AcademicAreaAdd from "./modules/academic/academicArea/add.vue";
import AcademicAreaEdit from "./modules/academic/academicArea/edit.vue";

import RoleRequestTable from "./modules/roleRequest/table.vue";
import RoleRequestView from "./modules/roleRequest/view.vue";
import RoleRequestViewAdmin from "./modules/roleRequest/view.admin.vue";

import AdminRoleRequestTable from "./modules/roleRequest/table.admin.vue";
import AdminResearchRoleRequestTable from "./modules/roleRequest/table.admin.research.vue";

import UserTable from "./modules/security/user/table.vue";
import UserBase from "./modules/security/user/base.vue";

import TermCondictionsAdd from "./modules/termCondiction/add.vue";
import TermCondictionsTable from "./modules/termCondiction/table.vue";
import TermCondictionEdit from "./modules/termCondiction/edit.vue";

import AnnouncementTable from "./modules/announcement/table.vue";
import AnnouncementAdd from "./modules/announcement/add.vue";
import AnnouncementEdit from "./modules/announcement/edit.vue";

import InitperiodTable from "./modules/periods/table.vue";
import InitperiodAdd from "./modules/periods/add.vue";
import InitperiodEdit from "./modules/periods/edit.vue";

import Roles from "@/modules/security/roles/roles.vue";
import Profile from "@/modules/profile/profile.vue";
import ProfileEdit from "@/modules/profile/edit-profile.vue";
import AddCurriculum from "@/modules/profile/addCurriculum.vue";
import AddCurriculumRefactored from "@/modules/profile/add-cv.vue";
import CurriculumUser from "@/modules/profile/curriculum.vue";
import ChangeRol from "@/modules/profile/changingRol.vue";

import Proposal from "@/modules/proposal/proposal.vue";
import PorposalEdit from "@/modules/proposal/porposal-edit.vue";
import PorposalDetail from "@/modules/proposal/porposal-detail.vue";
import PorposalDetailPrint from "@/components/porposal-detail-component/proposal-detail-to-print.vue";


import PorposalDetailEvaluation from "@/modules/proposal/porposal-detail-evaluation.vue";
import PorposalDetailResearchCenter from "@/modules/proposal/porposal-detail-research-center.vue";
import PorposalDetailFondocyt from "@/modules/proposal/proposal-detail-fondocyt.vue";
import ProjectByAnnoucement from './modules/proposal/projectByAnnoucement.vue';

import PorposalConfirmation from "@/modules/proposal/porposal-confirmation.vue";
import SendedPorposal from "@/modules/proposal/sendedPorposal.vue";
import PorposalHistory from "@/modules/proposal/porposalHistory.vue";
import ProposalPrioritization from "@/modules/proposal/proposal-prioritization.vue";
import ProposalSendedByResearchCenter from "@/modules/proposal/ProposalSendedByResearchCenter.vue";

import MyProjects from "@/modules/project/myprojects.vue";
import ReportDetail from "@/modules/project/reportDetail.vue";
import CompleteReport from "@/modules/project/completeReport.vue";
import ApprovalProjects from "@/modules/project/approvalProjects.vue";

import PorposalPendingEvaluations from "@/modules/proposal/porposal-pending-evaluations.vue";
import PorposalPendingReportEvaluations from "@/modules/proposal/porposal-pending-report-evaluations.vue";



import MemberTypeTable from "@/modules/proposal/porposalMemberType/table.vue";
import MemberTypeAdd from "@/modules/proposal/porposalMemberType/add.vue";
import MemberTypeEdit from "@/modules/proposal/porposalMemberType/edit.vue";

import ProjectTypeTable from "@/modules/proposal/porposalProjectType/table.vue";
import ProjectTypeAdd from "@/modules/proposal/porposalProjectType/add.vue";
import ProjectTypeEdit from "@/modules/proposal/porposalProjectType/edit.vue";


import AnnoucementTypeTable from "@/modules/announcement/annoucementType/table.vue";
import AnnoucementTypeAdd from "@/modules/announcement/annoucementType/add.vue";
import AnnoucementTypeEdit from "@/modules/announcement/annoucementType/edit.vue";

import InstitutionTable from "@/modules/proposal/TypeInstitutions/table.vue";
import InstitutionEdit from "@/modules/proposal/TypeInstitutions/edit.vue";
import InstitutionAdd from "@/modules/proposal/TypeInstitutions/add.vue";

import ContentTypeTable from "@/modules/proposal/contentType/table.vue";
import ContentTypeEdit from "@/modules/proposal/contentType/edit.vue";
import ContentTypeAdd from "@/modules/proposal/contentType/add.vue";

import CurrencyTable from "@/modules/proposal/currency/table.vue";
import CurrencyEdit from "@/modules/proposal/currency/edit.vue";
import CurrencyAdd from "@/modules/proposal/currency/add.vue";

import BudgetExpenseBase from "@/modules/proposal/budgetExpense/base.vue";
import BudgetExpenseTable from "@/modules/proposal/budgetExpense/table.vue";
import BudgetExpenseEdit from "@/modules/proposal/budgetExpense/edit.vue";
import BudgetExpenseAdd from "@/modules/proposal/budgetExpense/add.vue";

import BudgetItemBase from "@/modules/proposal/budgetExpense/budgetItem/base.vue";
import BudgetItemTable from "@/modules/proposal/budgetExpense/budgetItem/table.vue";
import BudgetItemEdit from "@/modules/proposal/budgetExpense/budgetItem/edit.vue";
import BudgetItemAdd from "@/modules/proposal/budgetExpense/budgetItem/add.vue";

import BudgetSubItemBase from "@/modules/proposal/budgetExpense/budgetSubItem/base.vue";
import BudgetSubItemTable from "@/modules/proposal/budgetExpense/budgetSubItem/table.vue";
import BudgetSubItemAdd from "@/modules/proposal/budgetExpense/budgetSubItem/add.vue";

import { PermissionValue } from "./enums/PermissionValue";

import Dashboard from "@/modules/Dashboard/dashboard.vue";
import Reports from "@/modules/Reports/reportes.vue";

import ProposalEvaluationDetail from '@/modules/proposal/proposal-evaluation-detail.vue';
//import ProposalEvaluationDetailCientificoTecnico from '@/modules/proposal/proposal-evaluation-detail.vue';
//import ProposalEvaluationDetailFinanciera from '@/modules/proposal/proposal-evaluation-detail.vue';

import BaseEvaluationType from "@/modules/EvaluationType/base.vue";
import EvaluationTypeTable from "@/modules/EvaluationType/table.vue";
import EvaluationTypeAdd from "@/modules/EvaluationType/add.vue";
import EvaluationTypeEdit from "@/modules/EvaluationType/edit.vue";

import BaseQuestion from "@/modules/EvaluationType/Questions/base.vue";
import QuestionTable from "@/modules/EvaluationType/Questions/table.vue";
import QuestionAdd from "@/modules/EvaluationType/Questions/add.vue";
import QuestionEdit from "@/modules/EvaluationType/Questions/edit.vue";

import ProposalUserReportIES from "@/modules/proposal/usersReports/user-report.vue";
import ProposalBudgetExecutionIES from "@/modules/proposal/budgetExecution/budget-execution-ies.vue";
import ProposalBudgetExecutionFondocyt from "@/modules/proposal/budgetExecution/budget-execution-fondocyt.vue";

import ProposalUserReportFondocyt from "@/modules/proposal/usersReports/user-report-fondocyt.vue";

import PorposalReportEvaluation from '@/modules/proposal/porposal-report-evaluation-detail.vue';
import PorposalBudgetReportEvaluation from '@/modules/proposal/porposal-budget-evaluation.vue';
import LastReportEvaluation from '@/modules/proposal/usersReports/last-report-evaluation.vue';

import ProposalHistory from "@/modules/proposal/history/proposal.vue";
import NationalInterest from "@/modules/nationalInterest/nationalInterest.vue";
import NationalInterestEdit from "@/modules/nationalInterest/nationalInterest-edit.vue";

import ProposalEditHistory from "@/modules/proposal/history/proposal-edit.vue";
import TableAudit from "@/modules/security/table-audit.vue";

import Faculties from "@/modules/faculties/base.vue"
import FacultiesAdd from "@/modules/faculties/add.vue"
import FacultyEdit from "@/modules/faculties/edit.vue"

import UrlForm from "@/modules/urlForm/base.vue"
import UrlFormTable from "@/modules/urlForm/table.vue"
import UrlFormAdd from "@/modules/urlForm/add.vue"
import UrlFormEdit from "@/modules/urlForm/edit.vue"
import NoFoundCookiesPage from "@/modules/noFoundCookiesPage.vue"

import store from "./store";
import IndicatorTypeConfigBase from './modules/Indicators/indicatorType/base.vue';
import IndicatorTypeTableComponent from './modules/Indicators/indicatorType/table.vue';
import IndicatorTypeAdd from './modules/Indicators/indicatorType/add.vue';
import IndicatorBase from './modules/Indicators/indicator/base.vue';
import IndicatorTableComponent from './modules/Indicators/indicator/table.vue';
import IndicatorAdd from './modules/Indicators/indicator/add.vue';
import IndicatorValueBase from './modules/Indicators/indicatorValue/base.vue';
import IndicatorValueTableComponent from './modules/Indicators/indicatorValue/table.vue';
import IndicatorValueAdd from './modules/Indicators/indicatorValue/add.vue';
import IndicatorBaseConfigBase from './modules/Indicators/indicatorGroup/base.vue';
import IndicatorGroupTableComponent from './modules/Indicators/indicatorGroup/table.vue';
import IndicatorGroupAdd from './modules/Indicators/indicatorGroup/add.vue';
import IndicatorGroupEdit from './modules/Indicators/indicatorGroup/edit.vue';
import IndicatorTypeBase from './modules/Indicators/indicatorType/base.vue';
import IndicatorTypeEdit from './modules/Indicators/indicatorType/edit.vue';
import IndicatorEdit from './modules/Indicators/indicator/edit.vue';

Vue.use(Router);

export class RoutesList {

  static getRoutes(): RouteConfig[] {


    return [
      {
        path: "/",
        redirect: "/inicio",
        meta: {
          requiresAuth: true,
          permissionValue: PermissionValue.INICIO,
          invisible: true
        }
      },
      {
        path: "/noFoundCookiesPage",
        component: NoFoundCookiesPage,
        meta: {
          invisible: true
        }
      },
      {
        path: "/inicio",
        name: "menu.home",
        component: Home,
        meta: {
          icon: "home",
          requiresAuth: true
        }
      },


      {
        path: "/indicatorGroup",
        name: "menu.indicators",
        component: IndicatorBaseConfigBase,
        meta: {
          icon: "translate",
          isParent:true,
          requiresAuth: true,
          permissionValue: PermissionValue.IDIOMAS
        },
        children: [

          {
            path: "/indicatorGroup",
            name: "menu.indicator",
            component: IndicatorGroupTableComponent,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.IDIOMAS

            }
          },
          {
            path: "/indicatorGroup/agregar",
            name: "menu.add",
            component: IndicatorGroupAdd,
            meta: {
              icon: "add_circle_outline",
              invisible: true,
              requiresAuth: true,
              permissionValue: PermissionValue.IDIOMAS
            }
          },
          {
            path: "/indicatorGroup/editar/:id",
            name: "menu.add",
            component: IndicatorGroupEdit,
            meta: {
              icon: "add_circle_outline",
              invisible: true,
              requiresAuth: true,
              permissionValue: PermissionValue.IDIOMAS
            }
          },
          {
            path: "",
            name: "IndicatorType",
            component: IndicatorTypeBase,
            meta: {
              invisible: true
            },
            children: [
              {
                path: "/indicatorGroup/:indicatorGroupId/indicatorType",
                component: IndicatorTypeTableComponent,
                meta: {
                  invisible: true
                }
              },
              {
                path: "/indicatorGroup/:indicatorGroupId/indicatorType/agregar",
                component: IndicatorTypeAdd,
                meta: {
                  invisible: true
                }
              },
              {
                path: "/indicatorGroup/:indicatorGroupId/indicatorType/editar/:id",
                component: IndicatorTypeEdit,
                meta: {
                  invisible: true
                }
              },
            ]
          },
          {
            path: "",
            name: "Indicator",
            component: IndicatorBase,
            meta: {
              invisible: true
            },
            children: [
              {
                path:
                  "/indicatorGroup/:indicatorGroupId/indicatorType/:indicatorTypeId/indicator",
                component: IndicatorTableComponent,
                meta: {
                  invisible: true
                }
              },
              {
                path:
                  "/indicatorGroup/:indicatorGroupId/indicatorType/:indicatorTypeId/indicator/agregar",
                component: IndicatorAdd,
                meta: {
                  invisible: true
                }
              },
              {
                path:
                  "/indicatorGroup/:indicatorGroupId/indicatorType/:indicatorTypeId/indicator/editar/:id",
                component: IndicatorEdit,
                meta: {
                  invisible: true
                }
              },
            ]
          },
          {
            path: "/indicatorValue",
            name: "menu.indicatorValue",
            component: IndicatorValueTableComponent,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.IDIOMAS

            }
          },
        ]
      },
      {
        path: "/nationalInterest",
        name: "menu.nationalInterest",
        component: NationalInterest,
        meta: {
          icon: "bank",
          requiresAuth: true,
          isInvestigator: true,
          isNationalInteres:true
        }
      },
      {
        path: "/nationalInterest-edit/:id",
        component: NationalInterestEdit,
        meta: {
          requiresAuth: true,
          invisible: true
        }
      },
      {
        path: "/Language",
        name: "menu.language",
        component: LanguageConfigBase,
        meta: {
          icon: "translate",
          requiresAuth: true,
          permissionValue: PermissionValue.IDIOMAS
        },
        children: [
          {
            path: "/Language",
            name: "menu.listed",
            component: LanguageTable,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.IDIOMAS

            }
          },

          {
            path: "/Language/agregar",
            name: "menu.add",
            component: LanguageAdd,
            meta: {
              icon: "add_circle_outline",
              invisible: true,
              requiresAuth: true,
              permissionValue: PermissionValue.IDIOMAS
            }
          },
          {
            path: "/Language/editar/:id",
            name: "Editar",
            component: LanguageEdit,
            meta: {
              index: 2.3,
              invisible: true
            }
          },
          {
            path: "",
            name: "Grupos",
            component: LanguageGroupBase,
            meta: {
              invisible: true
            },
            children: [
              {
                path: "/Language/:languageId/LanguageGroup",
                component: LanguageGroupTable,
                meta: {
                  invisible: true
                }
              },
              {
                path: "/Language/:languageId/LanguageGroup/agregar",
                component: LanguageGroupAdd,
                meta: {
                  invisible: true
                }
              },
              {
                path: "/language/:languageId/LanguageGroup/editar/:id",
                component: LanguageGroupEdit,
                meta: {
                  invisible: true
                }
              }
            ]
          },
          {
            path: "",
            name: "Label",
            component: LanguageLabelBase,
            meta: {
              invisible: true
            },
            children: [
              {
                path:
                  "/language/:languageId/LanguageGroup/:languageGroupId/LanguageLabel",
                component: LanguageLabelTable,
                meta: {
                  invisible: true
                }
              },
              {
                path:
                  "/language/:languageId/LanguageGroup/:languageGroupId/LanguageLabel/agregar",
                component: LanguageLabelAdd,
                meta: {
                  invisible: true
                }
              },
              {
                path:
                  "/language/:languageId/LanguageGroup/:languageGroupId/LanguageLabel/editar/:id",
                component: LanguageLabelEdit,
                meta: {
                  invisible: true
                }
              }
            ]
          }
        ]
      },
      {
        path: "/historico",
        name: "menu.respository",
        component: BaseHistory,
        meta: {
          icon: "cloud",
          requiresAuth: true,
          permissionValue: PermissionValue.HISTORICO
        },
        children: [
          {
            path: "/historico",
            component: HistoryChildTable,
            meta: {
              invisible: true,
              permissionValue: PermissionValue.HISTORICO
            }
          },
          {
            path: "/historico/agregar",
            component: HistoryAdd,
            meta: {
              invisible: true,
              permissionValue: PermissionValue.HISTORICO
            }
          },
          {
            path: "/historico/agregar/:id",
            component: HistoryAdd,
            meta: {
              invisible: true,
              permissionValue: PermissionValue.HISTORICO
            }
          },
          {
            path: "/historico/padre/:parentId",
            component: HistoryChildTable,
            meta: {
              invisible: true,
              permissionValue: PermissionValue.HISTORICO
            }
          },
          {
            path: "/historico/editar/:id",
            component: HistoryEdit,
            meta: {
              invisible: true,
              permissionValue: PermissionValue.HISTORICO
            }
          },
          {
            path: "/historico/editar/:id/parent/:parentId",
            component: HistoryEdit,
            meta: {
              invisible: true,
              permissionValue: PermissionValue.HISTORICO
            }
          }
        ]
      },



      // {
      //   path: "/tipo-investigacion",
      //   name: "menu.researchType",
      //   component: BaseView,
      //   meta: {
      //     index: 2.1,
      //     icon: "list",
      //     isParent: true,
      //     requiresAuth: true,
      //     permissionValue: PermissionValue.TIPOSCENTROINVESTIGACIONES
      //   },
      //   children: [
      //     {
      //       path: "/tipo-investigacion",
      //       name: "menu.ResearchType",
      //       component: ResearchTable,
      //       meta: {
      //         index: 2.0,
      //         icon: "list",
      //         requiresAuth: true
      //       }
      //     },
      //     {
      //       path: "/tipo-investigacion/editar/:id",
      //       name: "Editar",
      //       component: ResearchEdit,
      //       meta: {
      //         index: 2.3,
      //         invisible: true,
      //         requiresAuth: true
      //       }
      //     },
      //     {
      //       path: "/tipo-investigacion/agregar",
      //       name: "Agregar",
      //       component: ResearchAdd,
      //       meta: {
      //         index: 2.4,
      //         icon: "add_circle_outline",
      //         requiresAuth: true,
      //         invisible: true
      //       }
      //     }
      //   ]
      // },
      {
        path: "/centro-investigacion",
        name: "menu.researchCenter",
        component: BaseView,
        meta: {
          icon: "hospital-building",
          requiresAuth: true,
          permissionValue: PermissionValue.CENTROINVESTIGACIONES
        },
        children: [
          {
            path: "/centro-investigacion",
            name: "menu.ResearchCenter",
            component: ResearchCenterTable,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.CENTROINVESTIGACIONES
            }
          },
          {
            path: "/centro-investigacion/agregar",
            name: "Agregar",
            component: ResearchCenterAdd,
            meta: {
              icon: "add_circle_outline",
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/centro-investigacion/editar/:id",
            name: "Editar",
            component: ResearchCenterEdit,
            meta: {
              icon: "add_circle_outline",
              requiresAuth: true,
              invisible: true
            }
          }
        ]
      },
      {
        path: "/titulo-academico",
        name: "menu.academicTitle",
        component: BaseView,
        meta: {
          icon: "school",
          requiresAuth: true,
          permissionValue: PermissionValue.TITULOSACADEMICOS
        },
        children: [
          {
            path: "/titulo-academico",
            name: "Listado",
            component: AcademicTitleTable,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.TITULOSACADEMICOS

            }
          },
          {
            path: "/titulo-academico/agregar",
            name: "Agregar",
            component: AcademicTitleAdd,
            meta: {
              icon: "add_circle_outline",
              requiresAuth: true
            }
          },
          {
            path: "/titulo-academico/editar/:id",
            name: "Editar",
            component: AcademicTitleEdit,
            meta: {
              invisible: true,
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: "/url-formulario",
        name: "menu.urlForm",
        component: UrlForm,
        meta: {
          icon: "share",
          requiresAuth: true,
          permissionValue: PermissionValue.CUESTIONARIOONLINE
        },
        children: [
          {
            path: "/url-formulario",
            name: "Listado",
            component: UrlFormTable,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.CUESTIONARIOONLINE

            }
          },
          {
            path: "/url-formulario/agregar",
            name: "Agregar",
            component: UrlFormAdd,
            meta: {
              icon: "add_circle_outline",
              requiresAuth: true
            }
          },
          {
            path: "/url-formulario/editar/:id",
            name: "Editar",
            component: UrlFormEdit ,
            meta: {
              invisible: true,
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: "/area-academica",
        name: "menu.academicArea",
        component: BaseView,
        meta: {
          icon: "bank",
          requiresAuth: true,
          permissionValue: PermissionValue.AREASACADEMICAS
        },
        children: [
          {
            path: "/area-academica",
            name: "Listado",
            component: AcademicAreaTable,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.AREASACADEMICAS
            }
          },
          {
            path: "/area-academica/agregar",
            name: "Agregar",
            component: AcademicAreaAdd,
            meta: {
              icon: "add_circle_outline",
              requiresAuth: true
            }
          },
          {
            path: "/area-academica/editar/:id",
            name: "Editar",
            component: AcademicAreaEdit,
            meta: {
              invisible: true,
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: "/solicitud-role",
        name: "menu.requestRole",
        component: BaseView,
        meta: {
          icon: "message-text",
          requiresAuth: true
        },
        children: [
          {
            path: "/solicitud-role",
            name: "Listado",
            component: RoleRequestTable,
            meta: {
              icon: "list",
              requiresAuth: true
            }
          },
          {
            path: "/solicitud-role/view/:id",
            name: "View",
            component: RoleRequestView,
            meta: {
              invisible: true,
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: "/solicitud-role-admin",
        name: "menu.request",
        component: BaseView,
        meta: {
          icon: "paperclip",
          isParent: false,
          requiresAuth: true,
          permissionValue: PermissionValue.SOLICITUDROLE
        },
        children: [
          {
            path: "/solicitud-role-admin",
            name: "Listado",
            component: AdminRoleRequestTable,
            meta: {
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.SOLICITUDROLE

            }
          },
          {
            path: "/solicitud-role-admin/view/:id",
            name: "View",
            component: RoleRequestViewAdmin,
            meta: {
              invisible: true,
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: "/solicitud-role-admin-research-center",
        name: "menu.requestAdminResearchCenter",
        component: BaseView,
        meta: {
          icon: "certificate",
          isParent: false,
          requiresAuth: true,
          isAdminCenter: true
        },
        children: [
          {
            path: "/solicitud-role-admin-research-center",
            name: "Listado",
            component: AdminResearchRoleRequestTable,
            meta: {
              icon: "list",
              requiresAuth: true
            }
          },
          {
            path: "/solicitud-role-admin-research-center/view/:id",
            name: "View",
            component: RoleRequestViewAdmin,
            meta: {
              invisible: true,
              requiresAuth: true
            }
          }
        ]
      },
      // {
      //   path: "/key-value",
      //   name: "Key Value",
      //   component: BaseView,
      //   meta: {
      //     index: 2,
      //     icon: "list",
      //     isParent: true,
      //     requiresAuth:true,
      //     permissionValue: PermissionValue.CODIFICACIONES
      //   },
      //   children: [
      //     {
      //       path: "/key-value",
      //       name: "Listado",
      //       component: KeyValueTable,
      //       meta: {
      //         index: 2.1,
      //         icon: "list",
      //         requiresAuth: true
      //       }
      //     },
      //     {
      //       path: "/key-value/agregar",
      //       name: "Agregar",
      //       component: KeyValueAdd,
      //       meta: {
      //         index: 2.2,
      //         icon: "add_circle_outline",
      //         requiresAuth: true
      //       }
      //     },
      //     {
      //       path: "/key-value/editar/:id",
      //       name: "Editar",
      //       component: KeyValueEdit,
      //       meta: {
      //         index: 2.3,
      //         invisible: true,
      //         requiresAuth: true
      //       }
      //     }
      //   ]
      // },
      {
        path: "/Reportes",
        name: "menu.reports",
        component: BaseView,
        meta: {
          index: 2.1,
          icon: "directions",
          isParent: true,
          requiresAuth: true,
          permissionValue: PermissionValue.MODULOREPORTES,
          permissions: [PermissionValue.Dashboard]
        },
        children: [
          {
            path: "/solicitud-dashboards",
            name: "menu.dashboards",
            component: Dashboard,
            meta: {
              icon: "view-dashboard",
              requiresAuth: true,
              permissionValue: PermissionValue.Dashboard
              ,
            }
          },
          {
            path: "/reports",
            name: "menu.reports",
            component: Reports,
            meta: {
              icon: "view-dashboard",
              requiresAuth: true,
              permissionValue: PermissionValue.Dashboard
              ,
            }
          },
        ]
      },
      {
        path: "/convocatoria",
        name: "menu.announcement",
        component: BaseView,
        meta: {
          index: 2.1,
          icon: "book",
          isParent: true,
          requiresAuth: true,
          permissionValue: PermissionValue.MODULOCONVOCATORIAS,
          permissions: [PermissionValue.CONVOCATORIAS, PermissionValue.TERMINOSCONDICIONES, PermissionValue.PERIODO, PermissionValue.CODIFICACIONES]
        },
        children: [
          {
            path: "/convocatoria",
            name: "menu.announcement",
            component: AnnouncementTable,
            meta: {
              icon: "book",
              invisible: false,
              requiresAuth: true,
              permissionValue: PermissionValue.CONVOCATORIAS
            }
          },
          {
            path: "/convocatoria/agregar",
            name: "Agregar",
            component: AnnouncementAdd,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/editar/:id",
            name: "Editar",
            component: AnnouncementEdit,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/detail/:id",
            name: "view",
            component: viewDetail,
            meta: {
              invisible: true,
              requiresAuth: true
            }
          },
          {
            path: "/convocatoria/:id/propuesta",
            name: "Proposal",
            component: Proposal,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/:id",
            name: "PorposalEdit",
            component: PorposalEdit,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/:id/fondocyt",
            name: "PorposalEdit",
            component: PorposalEdit,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/:id/detail",
            name: "PorposalDetail",
            component: PorposalDetail,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/:id/detail/print",
            name: "PorposalDetail",
            component: PorposalDetailPrint,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/evaluaciones/:id/detail",
            name: "PorposalDetail",
            component: PorposalDetailEvaluation,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/researchcenter/:id/detail",
            name: "PorposalDetail",
            component: PorposalDetailResearchCenter,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/fondocyt/:id/detail",
            name: "PorposalDetail",
            component: PorposalDetailFondocyt,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/convocatoria/propuesta/:id/confirmation",
            name: "PorposalConfirmation",
            component: PorposalConfirmation,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/proyecto/reporte/:id",
            name: "ReportDetail",
            component: ReportDetail,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/proyecto/report/complete/:id",
            name: "CompleteReport",
            component: CompleteReport,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "/announcement-type",
            name: "menu.announcementType",
            component: BaseView,
            meta: {
              index: 2.1,
              icon: "alarm",
              requiresAuth: true,
              permissionValue: PermissionValue.ANNOUCEMENTTYPE
            },
            children: [
              {
                path: "/announcement-type",
                name: "menu.announcementType",
                component: AnnoucementTypeTable,
                meta: {
                  index: 2.0,
                  icon: "list",
                  requiresAuth: true,
                  permissionValue: PermissionValue.PERIODO
                }
              },
              {
                path: "/announcement-type/editar/:id",
                name: "Editar",
                component: AnnoucementTypeEdit,
                meta: {
                  index: 2.3,
                  invisible: true,
                  requiresAuth: true
                }
              },
              {
                path: "/announcement-type/agregar",
                name: "Agregar",
                component: AnnoucementTypeAdd,
                meta: {
                  index: 2.4,
                  icon: "add_circle_outline",
                  requiresAuth: true,
                  invisible: true
                }
              }
            ]
          },

          {
            path: "/term-condiction",
            name: "menu.termCondiction",
            component: BaseView,
            meta: {
              icon: "clipboard-text",
              requiresAuth: true,
              permissionValue: PermissionValue.TERMINOSCONDICIONES
            },
            children: [
              {
                path: "/term-condiction",
                name: "menu.termCondiction",
                component: TermCondictionsTable,
                meta: {
                  icon: "list",
                  requiresAuth: true,
                  permissionValue: PermissionValue.TERMINOSCONDICIONES
                }
              },
              {
                path: "/term-condiction/agregar",
                name: "Agregar",
                component: TermCondictionsAdd,
                meta: {
                  index: 2.4,
                  icon: "add_circle_outline",
                  requiresAuth: true,
                  invisible: true
                }
              },
              {
                path: "/term-condiction/editar/:id",
                name: "Editar",
                component: TermCondictionEdit,
                meta: {
                  index: 2.3,
                  invisible: true,
                  requiresAuth: true
                }
              }
            ]
          },
          {
            path: "/Period",
            name: "menu.period",
            component: BaseView,
            meta: {
              index: 2.1,
              icon: "alarm",
              requiresAuth: true,
              permissionValue: PermissionValue.PERIODO
            },
            children: [
              {
                path: "/Period",
                name: "menu.initperiod",
                component: InitperiodTable,
                meta: {
                  index: 2.0,
                  icon: "list",
                  requiresAuth: true,
                  permissionValue: PermissionValue.PERIODO
                }
              },
              {
                path: "/period/editar/:id",
                name: "Editar",
                component: InitperiodEdit,
                meta: {
                  index: 2.3,
                  invisible: true,
                  requiresAuth: true
                }
              },
              {
                path: "/period/agregar",
                name: "Agregar",
                component: InitperiodAdd,
                meta: {
                  index: 2.4,
                  icon: "add_circle_outline",
                  requiresAuth: true,
                  invisible: true
                }
              }
            ]
          },
          {
            path: "/Area",
            name: "menu.coding",
            component: BaseArea,
            meta: {
              index: 2.5,
              icon: "adjust",
              requiresAuth: true,
              permissionValue: PermissionValue.CODIFICACIONES
            },
            children: [
              {
                path: "/Area",
                name: "menu.area",
                component: AreaTable,
                meta: {
                  index: 2.2,
                  icon: "list",
                  requiresAuth: true,
                  permissionValue: PermissionValue.CODIFICACIONES
                }
              },
              {
                path: "/Area/agregar",
                name: "button_btn_add",
                component: AreaAdd,
                meta: {
                  requiresAuth: true,
                  index: 2.3,
                  icon: "add_circle_outline"
                }
              },
              {
                path: "/Area/editar/:id",
                name: "Editar",
                component: AreaEdit,
                meta: {
                  invisible: true
                }
              },
              {
                path: "",
                name: "fieldArea",
                component: FieldAreaBase,
                meta: {
                  invisible: true
                },
                children: [
                  {
                    path: "/Area/:areaId/FieldArea",
                    component: FieldAreaTable,
                    meta: {
                      invisible: true
                    }
                  },
                  {
                    path: "/Area/:areaId/FieldArea/agregar",
                    component: FieldAreaAdd,
                    meta: {
                      invisible: true
                    }
                  },
                  {
                    path: "/area/:areaId/FieldArea/editar/:id",
                    component: FieldAreaEdit,
                    meta: {
                      invisible: true
                    }
                  }
                ]
              },
              {
                path: "",
                name: "ResearchLine",
                component: ResearchLineBase,
                meta: {
                  invisible: true
                },
                children: [
                  {
                    path: "/Area/:areaId/FieldArea/:fieldAreaId/ResearchLine",
                    component: ResearchLineTable,
                    meta: {
                      invisible: true
                    }
                  },
                  {
                    path:
                      "/Area/:areaId/FieldArea/:fieldAreaId/ResearchLine/agregar",
                    component: ResearchLineAdd,
                    meta: {
                      invisible: true
                    }
                  },
                  {
                    path:
                      "/area/:areaId/FieldArea/:fieldAreaId/ResearchLine/editar/:id",
                    component: ResearchLineEdit,
                    meta: {
                      invisible: true
                    }
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        path: "/convocatoria/propuesta/:id/evaluation/:tipo",
        name: "menu.evaluationsDetailTitle",
        component: ProposalEvaluationDetail,
        meta: {
          index: 3.2,
          icon: "bell-ring",
          requiresAuth: true,
          isEvaluator: true,
          invisible: true
        }
      },
      {
        path: "/content-type",
        name: "menu.contentType",
        component: BaseView,
        meta: {
          index: 2.1,
          icon: "content-duplicate",
          requiresAuth: true,
          permissionValue: PermissionValue.TIPOCONTENIDO
        },
        children: [
          {
            path: "/content-type",
            name: "menu.contentType",
            component: ContentTypeTable,
            meta: {
              index: 4.0,
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.TIPOCONTENIDO

            }
          },
          {
            path: "/content-type/editar/:id",
            name: "Editar",
            component: ContentTypeEdit,
            meta: {
              index: 2.3,
              invisible: true,
              requiresAuth: true
            }
          },
          {
            path: "/content-type/agregar",
            name: "Agregar",
            component: ContentTypeAdd,
            meta: {
              index: 4.2,
              icon: "add_circle_outline",
              requiresAuth: true,
              invisible: true
            }
          }
        ]
      },

      {
        path: "/member-type",
        name: "menu.memberType",
        component: BaseView,
        meta: {
          index: 3.1,
          icon: "account-circle",
          requiresAuth: true,
          permissionValue: PermissionValue.TIPOMIEMBRO
        },
        children: [
          {
            path: "/member-type",
            name: "menu.memberType",
            component: MemberTypeTable,
            meta: {
              index: 3.1,
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.TIPOMIEMBRO
            }
          },
          {
            path: "/member-type/editar/:id",
            name: "Editar",
            component: MemberTypeEdit,
            meta: {
              index: 3.2,
              invisible: true,
              requiresAuth: true
            }
          },
          {
            path: "/member-type/agregar",
            name: "Agregar",
            component: MemberTypeAdd,
            meta: {
              index: 3.3,
              icon: "add_circle_outline",
              requiresAuth: true,
              invisible: true
            }
          },
        ]
      },
      {
        path: "/researchCenterCollaborator",
        name: "menu.researchCenterCollaborator",
        component: ResearchCenterCollaboratorBase,
        meta: {
          icon: "group",
          isAdminCenter: true,
        },
        children: [
          {
            path: "/researchCenterCollaborator",
            name: "menu.listed",
            component: ResearchCenterCollaboratorTable,
            meta: {
              icon: "list",
              isAdminCenter: true,
            }
          },
          {
            path: "/researchCenterCollaborator/agregar",
            name: "menu.add",
            component: ResearchCenterCollaboratorAdd,
            meta: {
              icon: "add_circle_outline",
              isAdminCenter: true,
            }
          }
        ]
      },
      {
        path: "/EvaluationType",
        name: "menu.evaluationType",
        component: BaseEvaluationType,
        meta: {
          icon: "poll",
          permissionValue: PermissionValue.TIPOEVALUACION
        },
        children: [
          {
            path: "/EvaluationType",
            name: "menu.listed",
            component: EvaluationTypeTable,
            meta: {
              icon: "list",
              permissionValue: PermissionValue.TIPOEVALUACION
            }
          },
          {
            path: "/EvaluationType/agregar",
            name: "menu.add",
            component: EvaluationTypeAdd,
            meta: {
              icon: "add_circle_outline",
              permissionValue: PermissionValue.TIPOEVALUACION
            }
          },
          {
            path: "/EvaluationType/editar/:id",
            name: "menu.add",
            component: EvaluationTypeEdit,
            meta: {
              icon: "add_circle_outline",
              permissionValue: PermissionValue.TIPOEVALUACION
            }
          },
          {
            path: "/EvaluationType/:id/Questions",
            name: "menu.EvaluationType",
            component: BaseQuestion,
            meta: {
              icon: "account-circle",
              invisible: true
            },
            children: [
              {
                path: "/EvaluationType/:id/Questions",
                name: "menu.listed",
                component: QuestionTable,
                meta: {
                  icon: "list",
                }
              },
              {
                path: "/EvaluationType/:id/Questions/agregar",
                name: "menu.add",
                component: QuestionAdd,
                meta: {
                  icon: "add_circle_outline",
                }
              },
              {
                path: "/EvaluationType/:id/Questions/editar/:id",
                name: "menu.add",
                component: QuestionEdit,
                meta: {
                  icon: "add_circle_outline",
                }
              }
            ]
          }
        ]
      },
      {
        path: "/budget-expense",
        name: "menu.budgetExpense",
        component: BudgetExpenseBase,
        meta: {
          index: 3.1,
          icon: "book-open",
          requiresAuth: true,
          permissionValue: PermissionValue.GASTOPRESUPUESTO,
          isParent: false
        },
        children: [
          {
            path: "/budget-expense",
            name: "menu.listed",
            component: BudgetExpenseTable,
            meta: {
              requiresAuth: true,
              icon: "list",
              permissionValue: PermissionValue.GASTOPRESUPUESTO,
            }
          },
          {
            path: "/budget-expense/agregar",
            name: "menu.add",
            component: BudgetExpenseAdd,
            meta: {
              requiresAuth: true,
              icon: "add_circle_outline"
            }
          },
          {
            path: "/budget-expense/editar/:id",
            name: "Editar",
            component: BudgetExpenseEdit,
            meta: {
              requiresAuth: true,
              invisible: true
            }
          },
          {
            path: "",
            name: "budget-item",
            component: BudgetItemBase,
            meta: {
              requiresAuth: true,
              permissionValue: PermissionValue.GASTOPRESUPUESTO,
              invisible: true
            },
            children: [
              {
                path: "/budget-expense/:budgetExpenseId/budget-item",
                component: BudgetItemTable,
                meta: {
                  requiresAuth: true,
                  invisible: true

                }
              },
              {
                path: "/budget-expense/:budgetExpenseId/budget-item/agregar",
                component: BudgetItemAdd,
                meta: {
                  requiresAuth: true,
                  invisible: true
                }
              },
              {
                path: "/budget-expense/:budgetExpenseId/budget-item/editar/:id",
                component: BudgetItemEdit,
                meta: {
                  requiresAuth: true,
                  invisible: true
                }
              }
            ]
          },
          {
            path: "",
            name: "budget-sub-item",
            component: BudgetSubItemBase,
            meta: {
              requiresAuth: true,
              permissionValue: PermissionValue.GASTOPRESUPUESTO,
              invisible: true
            },
            children: [
              {
                path:
                  "/budget-expense/:budgetExpenseId/budget-item/:budgetItemId/budget-sub-item",
                component: BudgetSubItemTable,
                meta: {
                  requiresAuth: true,
                  invisible: true
                }
              },
              {
                path:
                  "/budget-expense/:budgetExpenseId/budget-item/:budgetItemId/budget-sub-item/agregar",
                component: BudgetSubItemAdd,
                meta: {
                  requiresAuth: true,
                  invisible: true
                }
              },
              {
                path:
                  "/budget-expense/:budgetExpenseId/budget-item/:budgetItemId/budget-sub-item/editar/:id",
                component: BudgetItemEdit,
                meta: {
                  invisible: true,
                  requiresAuth: true
                }
              }
            ]
          }
        ]
      },

      {
        path: "/project-type",
        name: "menu.projectType",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "briefcase",
          requiresAuth: true,
          permissionValue: PermissionValue.TIPOPROYECTO
        },
        children: [
          {
            path: "/project-type",
            name: "menu.projectType",
            component: ProjectTypeTable,
            meta: {
              index: 3.1,
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.TIPOPROYECTO
            }
          },
          {
            path: "/project-type/editar/:id",
            name: "Editar",
            component: ProjectTypeEdit,
            meta: {
              index: 3.2,
              invisible: true,
              requiresAuth: true
            }
          },
          {
            path: "/project-type/agregar",
            name: "Agregar",
            component: ProjectTypeAdd,
            meta: {
              index: 3.3,
              icon: "add_circle_outline",
              requiresAuth: true,
              invisible: true
            }
          }
        ]
      },
      {
        path: "/institution",
        name: "menu.institution",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "domain",
          requiresAuth: true,
          permissionValue: PermissionValue.INSTITUCION
        },
        children: [
          {
            path: "/institution",
            name: "menu.institution",
            component: InstitutionTable,
            meta: {
              index: 5.1,
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.INSTITUCION
            }
          },
          {
            path: "/institution/editar/:id",
            name: "Editar",
            component: InstitutionEdit,
            meta: {
              index: 3.2,
              invisible: true,
              requiresAuth: true
            }
          },
          {
            path: "/institution/agregar",
            name: "Agregar",
            component: InstitutionAdd,
            meta: {
              index: 3.3,
              icon: "add_circle_outline",
              requiresAuth: true,
              invisible: true
            }
          }
        ]
      },
      {
        path: "/proposal-prioritization",
        name: "menu.prioritizationPorposals",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "sort",
          requiresAuth: true,
          permissionValue: PermissionValue.PRIORIZACIONPROPUESTA
        },
        children: [
          {
            path: "/proposal-prioritization",
            name: "menu.prioritizationPorposals",
            component: ProposalPrioritization,
            meta: {
              index: 3.1,
              icon: "fa-sort-asc",
              requiresAuth: true,
              permissionValue: PermissionValue.PRIORIZACIONPROPUESTA
            }
          }
        ]
      },
      {
        path: "/proposal-recived",
        name: "menu.recivePorposals",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "email",
          isAdminOrCollaborator: true,
          requiresAuth: true
        },
        children: [
          {
            path: "/proposal-recived",
            name: "menu.recivePorposals",
            component: SendedPorposal,
            meta: {
              index: 3.1,
              icon: "email",
              requiresAuth: true,
              isAdminOrCollaborator: true,
            }
          }
        ]
      },
      {
        path: "/recived-reports-ies",
        name: "menu.reciveReportsIES",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "forward",
          requiresAuth: true,
          isAdminOrCollaborator: true,
        },
        children: [
          {
            path: "/recived-reports-ies",
            name: "menu.reciveReportsIES",
            component: ProposalUserReportIES,
            meta: {
              index: 3.1,
              icon: "bell-ring",
              requiresAuth: true,
              isAdminOrCollaborator: true,
            }
          }
        ]
      },
      // {
      //   path: "/recived-budget-execution-ies",
      //   name: "menu.reciveBudgetExecutionIES",
      //   component: ProposalBudgetExecutionIES,
      //   meta: {
      //     index: 3.2,
      //     icon: "bell-ring",
      //     requiresAuth: true,
      //     isAdminCenter: true,
      //   }
      // },
      // {
      //   path: "/recived-budget-execution-fondocyt",
      //   name: "menu.reciveBudgetExecutionFondocyt",
      //   component: ProposalBudgetExecutionFondocyt,
      //   meta: {
      //     index: 3.2,
      //     icon: "bell-ring",
      //     requiresAuth: true,
      //     //isAdminCenter: true,
      //     permissionValue: PermissionValue.EJECUCIONPRESUPUESTARIAFONDOCYT
      //   }
      // },
      {
        path: "/proposal-pending-evaluations",
        name: "menu.pendingEvaluations",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "bell-ring",
          requiresAuth: true,
          isEvaluator: true
        },
        children: [
          {
            path: "/proposal-pending-evaluations",
            name: "menu.pendingEvaluations",
            component: PorposalPendingEvaluations,
            meta: {
              index: 3.2,
              icon: "bell-ring",
              requiresAuth: true,
              isEvaluator: true
            }
          },
        ]
      },
      {
        path: "/proposal/pendingReports/evaluations",
        name: "menu.pendingReportEvaluations",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "bell-ring",
          requiresAuth: true,
          isReportEvaluator: true
        },
        children: [
          {
            path: "/proposal/pendingReports/evaluations",
            name: "menu.pendingReportEvaluations",
            component: PorposalPendingReportEvaluations,
            meta: {
              index: 3.2,
              icon: "bell-ring",
              requiresAuth: true,
              isReportEvaluator: true
            }
          },
        ]
      },
      {
        path: "/propuesta/report/:rid/detail",
        name: "menu.proposalReportEvaluationDetail",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "bell-ring",
          requiresAuth: true,
          isReportEvaluator: true,
          invisible: true
        },
        children: [
          {
            path: "/propuesta/report/:rid/detail",
            name: "menu.proposalReportEvaluationDetail",
            component: PorposalReportEvaluation,
            meta: {
              index: 3.2,
              icon: "bell-ring",
              requiresAuth: true,
              isReportEvaluator: true,
              invisible: true
            }
          },
        ]
      },
      {
        path: "/propuesta/report/budget/:rid/detail",
        name: "menu.proposalReportEvaluationDetail",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "bell-ring",
          requiresAuth: true,
          isReportEvaluator: true,
          invisible: true
        },
        children: [
          {
            path: "/propuesta/report/budget/:rid/detail",
            name: "menu.proposalReportEvaluationDetail",
            component: PorposalBudgetReportEvaluation,
            meta: {
              index: 3.2,
              icon: "bell-ring",
              requiresAuth: true,
              isReportEvaluator: true,
              invisible: true
            }
          },
        ]
      },
      {
        path: "/proposal-recived-fondocyt",
        name: "menu.recivePorposalsFondocyt",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "email",
          requiresAuth: true,
          permissionValue: PermissionValue.PROPUESTASFONDOCYT
        },
        children: [
          {
            path: "/proposal-recived-fondocyt",
            name: "menu.recivePorposalsFondocyt",
            component: ProposalSendedByResearchCenter,
            meta: {
              index: 3.1,
              icon: "email",
              requiresAuth: true,
              permissionValue: PermissionValue.PROPUESTASFONDOCYT
            }
          }
        ]
      },
      {
        path: "/recived-reports-fondocyt",
        name: "menu.reciveReportsFondocyt",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "waves",
          requiresAuth: true,
          permissionValue: PermissionValue.REPORTEPORPROPUESTA
        },
        children: [
          {
            path: "/recived-reports-fondocyt",
            name: "menu.reciveReportsFondocyt",
            component: ProposalUserReportFondocyt,
            meta: {
              index: 3.1,
              icon: "bell-ring",
              requiresAuth: true,
              permissionValue: PermissionValue.REPORTEPORPROPUESTA
            }
          }
        ]
      },
      {
        path: "/porposalHistory",
        name: "menu.minePorposals",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "navigation",
          requiresAuth: true,
          isInvestigator: true
        },
        children: [
          {
            path: "/porposalHistory",
            name: "Mis Propuestas",
            component: PorposalHistory,
            meta: {
              index: 3.1,
              icon: "navigation",
              requiresAuth: true,
              isInvestigator: true
            }
          }
        ]
      },
      {
        path: "/projects",
        name: "menu.myProjects",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "folder",
          requiresAuth: true,
          isInvestigator: true
        },
        children: [
          {
            path: "/projects",
            name: "menu.myProjects",
            component: MyProjects,
            meta: {
              index: 3.1,
              icon: "folder",
              requiresAuth: true,
              isInvestigator: true
            }
          }
        ]
      },
      {
        path: "/approvalProjects",
        name: "menu.approvalProjects",
        component: BaseView,
        meta: {
          icon: "poll",
          requiresAuth: true,
          isAdminOrCollaborator: true,
        },
        children: [
          {
            path: "/approvalProjects",
            name: "menu.approvalProjects",
            component: ApprovalProjects,
            meta: {
              icon: "list",
              requiresAuth: true,
              isAdminOrCollaborator: true,
            }
          }
        ]
      },

      {
        path: "/project-by-annoucement",
        name: "menu.projectByAnnoucement",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "archive",
          requiresAuth: true,
          permissionValue: PermissionValue.PROYECTOPORCONVOCATORIA
        },
        children: [
          {
            path: "/project-by-annoucement",
            name: "menu.projectByAnnoucement",
            component: ProjectByAnnoucement,
            meta: {
              index: 3.1,
              icon: "move_to_inbox",
              requiresAuth: true,
              permissionValue: PermissionValue.PROYECTOPORCONVOCATORIA
            }
          },
        ]
      },
      {
        path: "/currency",
        name: "menu.currency",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "currency-usd",
          isParent: false,
          requiresAuth: true,
          permissionValue: PermissionValue.MONEDA
        },
        children: [
          {
            path: "/currency",
            name: "menu.currency",
            component: CurrencyTable,
            meta: {
              index: 3.1,
              icon: "list",
              requiresAuth: true,
              permissionValue: PermissionValue.MONEDA

            }
          },
          {
            path: "/currency/editar/:id",
            name: "Editar",
            component: CurrencyEdit,
            meta: {
              index: 3.2,
              invisible: true,
              requiresAuth: true
            }
          },
          {
            path: "/currency/agregar",
            name: "Agregar",
            component: CurrencyAdd,
            meta: {
              index: 3.3,
              icon: "add_circle_outline",
              requiresAuth: true,
              invisible: true
            }
          }
        ]
      },
      {
        path: "",
        name: "menu.security",
        component: BaseView,
        meta: {
          index: 3.2,
          icon: "lock",
          requiresAuth: true,
          isParent: true,
          permissionValue: PermissionValue.SEGURIDAD,
          permissions: [PermissionValue.ROLES, PermissionValue.USUARIOS, PermissionValue.AUDITORIA]
        },
        children: [
          {
            path: "/audit",
            name: "menu.audit",
            component: TableAudit,
            meta: {
              index: 3.1,
              icon: "lock",
              requiresAuth: true,
              permissionValue: PermissionValue.AUDITORIA
            }
          },
          {
            path: "/roles",
            name: "menu.roles",
            component: Roles,
            meta: {
              index: 3.1,
              icon: "lock",
              requiresAuth: true,
              permissionValue: PermissionValue.ROLES
            }
          },
          {
            path: "/users",
            name: "menu.users",
            component: UserBase,
            meta: {
              icon: "account-circle",
              requiresAuth: true,
              permissionValue: PermissionValue.USUARIOS
            },
            children: [
              {
                path: "/users",
                name: "menu.users",
                component: UserTable,
                meta: {
                  icon: "account-circle",
                  requiresAuth: true,
                  permissionValue: PermissionValue.USUARIOS
                }
              },
              {
                path: "/user/:usuarioId/roles",
                name: "user-roles-list",
                component: Roles,
                meta: {
                  invisible: true,
                  requiresAuth: true,
                  permissionValue: PermissionValue.ROLES
                }
              }
            ]
          }
        ]
      },
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: {
          requiresAuth: true,
          invisible: true
        }
      },
      {
        path: "/profile/edit",
        name: "ProfileEdit",
        component: ProfileEdit,
        meta: {
          requiresAuth: true,
          invisible: true
        }
      },
      {
        path: "/profile/curriculum",
        name: "CurriculumUser",
        component: CurriculumUser,
        meta: {
          requiresAuth: true,
          invisible: true
        },
        children: [
          {
            path: "/curriculum/:id",
            name: "curriculumUser",
            component: CurriculumUser,
            meta: {
              index: 3.1,
              requiresAuth: true,
            }
          }
        ]
      },
      {
        path: "/profile/changeRol",
        name: "Cambiarderol",
        component: ChangeRol,
        meta: {
          requiresAuth: true,
          invisible: true,
          isAdminCenter: true
        }
      },
      {
        path: "/profile/addCurriculum",
        name: "curriculum",
        component: AddCurriculumRefactored,
        meta: {
          requiresAuth: true,
          invisible: true,
        }
      },
      {
        path: "/profile/addCurriculum/optimized",
        name: "curriculum",
        component: AddCurriculumRefactored,
        meta: {
          requiresAuth: true,
          invisible: true,
        }
      },
      {
        path: "/EvaluateLastReport/:rid",
        name: "lastReport",
        component: LastReportEvaluation,
        meta: {
          requiresAuth: true,
          invisible: true,
        }
      },
      {
        path: "*", redirect: "/",
        meta: {
          requiresAuth: true,
          invisible: true,
        }
      },
      {
        path: "/proposal-history",
        name: "Proposal",
        component: ProposalHistory,
        meta: {
          requiresAuth: true,
          invisible: true
        }
      },
      {
        path: "/proposal-edit-history/:id",
        name: "Proposal",
        component: ProposalEditHistory,
        meta: {
          requiresAuth: true,
          invisible: true
        }
      },
      {
        path: "/faculties",
        name: "menu.faculties",
        component: Faculties,
        meta: {
          icon: "briefcase",
          requiresAuth: true,
          isAdminOrCollaborator: true,
        }
      },
      {
        path: "/faculties/:id",
        name: "menu.faculties",
        component: Faculties,
        meta: {
          icon: "briefcase",
          invisible: true,
          requiresAuth: true,
          isAdminOrCollaborator: true,
        }
      },
      {
        path:"/faculties/agregar/:id",
        component: FacultiesAdd,
        meta: {
          invisible: true,
          requiresAuth: true,
          isAdminOrCollaborator: true,
        }
      },
      {
        path:"/faculties/:fid/editar/:id",
        component: FacultyEdit,
        meta: {
          invisible: true,
          requiresAuth: true,
          isAdminOrCollaborator: true,
        }
      },
    ];
  }
}
const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  base: process.env.BASE_URL,
  routes: RoutesList.getRoutes(),
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

export default router;
